<template>
  <EntityEditCard :title="$t('servicesystem.common_objects.model.sync_options')" :item="machineModel"
    :saveMethod="saveMethod">
    <template v-slot:content="{ item, editMode, handleFocus }">

      <v-container fluid>
            <QTextField v-model="item.CentralSystemId"
              :label="$t('servicesystem.common_objects.model.central_system_id')" :externaledit="editMode"
              @FocusState="handleFocus">
            </QTextField>
            <QCheckboxInput v-model="item.RemoveLocalDocuments"
              :label="$t('servicesystem.common_objects.model.remove_local_documents')" :externaledit="editMode" class="mt-4"
              @FocusState="handleFocus">
            </QCheckboxInput>
            <QCheckboxInput v-model="item.RemoveLocalCommonArticles"
              :label="$t('servicesystem.common_objects.model.remove_local_common_parts')" :externaledit="editMode" class="mt-4"
              @FocusState="handleFocus">
            </QCheckboxInput>
      </v-container>

    </template>
  </EntityEditCard>
</template>


<script>
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";

export default {
  name: "MachineModelSyncOptions",
  props: {
    machineModel: Object,
    saveMethod: Function,
  },
  components: {
    EntityEditCard,
  },
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>